/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

// src/components/software/SoftwareEcosystem.jsx

import React from "react";

import {
  Globe,
  Smartphone,
  Monitor,
  Cloud,
  ArrowRight,
} from "lucide-react";

const SoftwareEcosystem = () => {

  return (

    <section className="py-24 px-6 lg:px-10">

      <div
        className="
          max-w-7xl
          mx-auto

          grid
          lg:grid-cols-2
          gap-10

          items-center
        "
      >

        {/* =====================================
            LEFT
        ===================================== */}

        <div className="space-y-8">

          <div>

            <div
              className="
                inline-flex
                items-center
                gap-2

                px-4
                py-2

                rounded-full

                bg-blue-100
                text-blue-700

                font-semibold

                mb-6
              "
            >
              Orion Platform Vision
            </div>

            <h2
              className="
                text-5xl
                font-black
                leading-tight
                mb-6
              "
            >
              One Platform.
              <br />
              Multiple Experiences.
            </h2>

            <p
              className="
                text-lg
                text-gray-600
                leading-relaxed
              "
            >
              Orion Analytics is evolving
              into a complete financial
              intelligence ecosystem.

              Access analytics through the
              web, manage tools on mobile
              and eventually experience
              Orion across every device.
            </p>

          </div>

          {/* HIGHLIGHTS */}

          <div className="space-y-5">

            <div className="flex gap-4">

              <div
                className="
                  w-12
                  h-12

                  rounded-xl

                  bg-green-100
                  text-green-700

                  flex
                  items-center
                  justify-center
                "
              >
                <Cloud size={22} />
              </div>

              <div>

                <div className="font-bold">
                  Unified Cloud Platform
                </div>

                <div className="text-gray-500">
                  Shared intelligence,
                  data and future account
                  synchronization.
                </div>

              </div>

            </div>

            <div className="flex gap-4">

              <div
                className="
                  w-12
                  h-12

                  rounded-xl

                  bg-blue-100
                  text-blue-700

                  flex
                  items-center
                  justify-center
                "
              >
                <Smartphone size={22} />
              </div>

              <div>

                <div className="font-bold">
                  Mobile First Expansion
                </div>

                <div className="text-gray-500">
                  Orion Edge today.
                  Orion Mobile tomorrow.
                </div>

              </div>

            </div>

            <div className="flex gap-4">

              <div
                className="
                  w-12
                  h-12

                  rounded-xl

                  bg-purple-100
                  text-purple-700

                  flex
                  items-center
                  justify-center
                "
              >
                <Monitor size={22} />
              </div>

              <div>

                <div className="font-bold">
                  Future Desktop Experience
                </div>

                <div className="text-gray-500">
                  Advanced research and
                  analytics workspaces.
                </div>

              </div>

            </div>

          </div>

        </div>


        {/* =====================================
            RIGHT
        ===================================== */}

        <div
          className="
            bg-white

            rounded-[32px]

            p-10

            shadow-[0_10px_40px_rgba(0,0,0,0.06)]

            border
            border-gray-100
          "
        >

          <div className="text-center">

            <div
              className="
                text-sm
                uppercase
                tracking-[0.3em]

                text-blue-700
                font-bold

                mb-10
              "
            >
              Ecosystem Architecture
            </div>

          </div>

          {/* CLOUD */}

          <div className="flex justify-center">

            <div
              className="
                w-28
                h-28

                rounded-3xl

                bg-blue-100
                text-blue-700

                flex
                flex-col
                items-center
                justify-center

                font-bold
              "
            >
              <Cloud size={34} />

              <div className="mt-2">
                Orion Cloud
              </div>

            </div>

          </div>

          {/* ARROW */}

          <div
            className="
              flex
              justify-center
              py-6
            "
          >
            <ArrowRight
              size={26}
              className="
                rotate-90
                text-gray-400
              "
            />
          </div>

          {/* PRODUCTS */}

          <div
            className="
              grid
              grid-cols-3
              gap-5
            "
          >

            <div
              className="
                bg-green-50
                rounded-2xl
                p-5
                text-center
              "
            >

              <Globe
                className="
                  mx-auto
                  mb-3
                  text-green-700
                "
              />

              <div className="font-bold">
                Analytics
              </div>

              <div
                className="
                  text-xs
                  text-gray-500
                "
              >
                Web Platform
              </div>

            </div>


            <div
              className="
                bg-blue-50
                rounded-2xl
                p-5
                text-center
              "
            >

              <Smartphone
                className="
                  mx-auto
                  mb-3
                  text-blue-700
                "
              />

              <div className="font-bold">
                Edge
              </div>

              <div
                className="
                  text-xs
                  text-gray-500
                "
              >
                Mobile Toolkit
              </div>

            </div>


            <div
              className="
                bg-purple-50
                rounded-2xl
                p-5
                text-center
              "
            >

              <Monitor
                className="
                  mx-auto
                  mb-3
                  text-purple-700
                "
              />

              <div className="font-bold">
                Mobile
              </div>

              <div
                className="
                  text-xs
                  text-gray-500
                "
              >
                Coming Soon
              </div>

            </div>

          </div>

        </div>

      </div>

    </section>

  );

};

export default SoftwareEcosystem;